import {
  validAdress,
  isChileAdress,
  isRequired,
  isBusinessName,
  isStringWithSpacesWithAccentsWithoutSpecialCharacters,
  isStringWithoutMoreOrLess,
  businessLength,
  addressInfoLength,
} from '@helpers/validator';

import { isNumber } from 'common-validator-fif-payments';

const Schema = {
  merchant_name: {
    type: 'text',
    errorMessage: [
      'errors.name.required',
      'errors.name.longLength',
      'errors.name.notMoreOrLess',
      'errors.name.validRepresentant',
    ],
    isValid: [
      (value) => value.length > 0,
      (value) => businessLength(value),
      (value) => isStringWithoutMoreOrLess(value),
      (value) => isBusinessName(value),
    ],
  },
  rut: {
    // No se da posibilidad de editar el rut en <FormCommerce />
    type: 'text',
    errorMessage: [],
    isValid: [],
  },
  formatted_address: {
    type: 'text',
    errorMessage: [
      'errors.common.invalidAddress',
      'errors.common.minimumLength',
      'errors.common.onlyNumbersAndLetters',
      'errors.address.incorrectAddress',
    ],
    isValid: [
      (value) => isRequired(value),
      (value) => validAdress(value),
      (value) =>
        isStringWithSpacesWithAccentsWithoutSpecialCharacters(
          value.replace(/,/g, '').replace(/'/g, '').replace(/\./g, '')
        ),
      (value) => isChileAdress(value),
    ],
  },
  address_info: {
    type: 'text',
    errorMessage: ['errors.address_info.longLength', 'errors.common.notMoreOrLess'],
    isValid: [(value) => addressInfoLength(value), (value) => isStringWithoutMoreOrLess(value)],
  },
  zip_code: {
    type: 'text',
    errorMessage: ['errors.common.zipCode', 'errors.common.zipCode'],
    isValid: [
      (value) => value.split('-')[0]?.trim().length === 7,
      (value) => isNumber(value.split('-')[0]?.trim()),
    ],
  },
  business_name: {
    // No se da posibilidad de editar business_name en <FormCommerce />
    type: 'text',
    errorMessage: [],
    isValid: [],
  },
  one_day_company: {
    // No se da posibilidad de editar one_day_company en <FormCommerce />
    type: 'text',
    errorMessage: [],
    isValid: [],
  },
};

export default Schema;
